// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"search_main-module__searchContainer--3ycF1","filtersOpen":"search_main-module__filtersOpen--1ZHsy"};